export const PRODUCT_DETAILS = 'PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-cashier/store/mutations-types.js